// modules
import { combineReducers } from 'redux'
// reducers
import fileDropZoneReducer from '../components/fileDropZone/fileDropZone.reducer'

export default combineReducers({
  fileDropZone: fileDropZoneReducer,
})
